import { TrackerType } from '@futrli/shared-services';

import { trackPendoEvent } from './pendo/tracking';

/**
 * Function that returns tracking utils to be used within your package
 * @param getTracker - function that will return the latest tracker instance
 */
export const eventTracker = (getTracker: () => TrackerType) => {
  /**
   * Makes a 'CTA clicked' style tracking call using the supplied tracker instance / parameters
   */
  const trackCTA = (eventTitle: string, buttonText: string, props: Record<string, string | number | boolean> = {}) => {
    getTracker().track(`${eventTitle} CTA clicked`, {
      'CTA text': buttonText,
      ...props
    });
  };

  /**
   * Makes a tracking call using the supplied tracker instance / parameters. This event is also sent to Pendo
   */
  const trackEvent = (eventName: string, props?: Record<string, string | number | boolean>) => {
    getTracker().track(eventName, props);
    trackPendoEvent(eventName, props);
  };

  /**
   * Makes a 'View Modal' style tracking call using the supplied tracker instance / parameters
   */
  const trackViewModal = (modalName: string, props: Record<string, string | number | boolean> = {}) => {
    getTracker().track(`View Modal - ${modalName}`, {
      'Modal name': modalName,
      ...props
    });
  };

  return {
    trackCTA,
    trackEvent,
    trackViewModal
  };
};
